import { forwardRef } from "react";
import MuiAlert from "@mui/material/Alert";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert ref={ref} {...props} />;
});

export default Alert;
